module.exports = __webpack_public_path__ + "img/H000080_blackcap.2b88889c.png";